import { render, staticRenderFns } from "./QuizAnswer.vue?vue&type=template&id=01506aac&"
import script from "./QuizAnswer.vue?vue&type=script&lang=js&"
export * from "./QuizAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports